import { render } from "./Earners.vue?vue&type=template&id=cbe13e64&lang=pug"
import script from "./Earners.vue?vue&type=script&lang=js"
export * from "./Earners.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__